import * as Types from '../mutation-types'
import { getEmployeeCostData } from '../queries.graphql'
import gqlClient from '@/modules/graphql'
import api from "@/modules/api"
import Promise from 'bluebird'

const employeeCostActions = {
  async loadEmployeeCostData({ commit }, variables = {}) {
    try {
      commit(Types.LOAD_EMPLOYEE_COST_DATA_BEGIN)
      
      const { data: { data: { appUser } } } = await gqlClient
        .query({
          query     : getEmployeeCostData,
          variables : variables
        })

      commit(Types.LOAD_EMPLOYEE_COST_DATA_SUCCESS, appUser)
    } catch (e) {
      commit(Types.LOAD_EMPLOYEE_COST_DATA_ERROR, e)
    }
  },
  setUserBenefitEditMode({ commit }, value){
    commit(Types.SET_EMPLOYEE_BENEFIT_EDIT_MODE, value)
  },
  setUserCostEditMode({ commit }, value){
    commit(Types.SET_EMPLOYEE_COST_EDIT_MODE, value)
  },
  /* eslint-disable camelcase */
  async updateUserCosts({ commit }, { userId, data:{ cost, cost_type, userPositions } }) {
    try {
      commit(Types.UPDATE_EMPLOYEE_COSTS_BEGIN)
      
      const updatedData = await Promise.all([
        api.userCost.updateEmployeeCosts(userId, { cost, cost_type }),
        ...userPositions.map(up => api.userPosition.update(up.id, { hourlyRate : up.hourlyRate }))
      ])
      
      commit(Types.UPDATE_EMPLOYEE_COSTS_SUCCESS, updatedData)
    } catch (e) {
      commit(Types.UPDATE_EMPLOYEE_COSTS_ERROR, e)
    }
  },
  async updateUserBenefitCosts({ commit }, mappedCostsById){
    try {
      commit(Types.UPDATE_USER_BENEFIT_COST_BEGIN)

      const userBenefits = Object.keys(mappedCostsById).map(id => ({ id, cost : mappedCostsById[id] || 0 }))

      const updatedData = await Promise.map(userBenefits,ub => api.userBenefit.update(ub.id, { cost : ub.cost }))
      
      commit(Types.UPDATE_USER_BENEFIT_COST_SUCCESS, updatedData)
    } catch (e) {
      commit(Types.UPDATE_USER_BENEFIT_COST_ERROR, e)
    }
  }

}

export default employeeCostActions
